import { getUser, getAlumniId, getToken, getKey, removeSession, refreshPage } from "Helpers/Utils/Common";
import { postAPICall, postAPICallCustom } from "../axiosMethodCalls";

/***************************
 * USER
 ***************************/

const token = getToken();
const user = getUser();

//POST
export const getPersonalInformation= async (id) => {
    try {
        const response = await postAPICall(process.env.REACT_APP_LINK + "alumnae/get", {
            requester: user,
            token: token,
            alumni_id: user,
        });
        return ({data:response.data.data});   
    } catch (error) {
        if (error.response.status === 401) {
          // toast.error(
          //   "Unauthorized access: another device is using this account"
          // );
          removeSession();
          refreshPage();
        }
        return ({error: error.response});
    }
  }

export const updateSocialMedia = async (id, data) => {
  try {
      const response = await postAPICall(process.env.REACT_APP_LINK + "alumnae/update_soc_med", {
          requester: user,
          token: token,
          alumni_id: user,
          facebook: data.facebook,
          linkedin: data.linkedin,
          twitter: data.twitter,
          instagram: data.instragam,
          github: data.github,
          youtube: data.youtube,
          personal_website: data.personal_website,
          
      });
      return ({data:response});   
  } catch (error) {
      if (error.response.status === 401) {
        // toast.error(
        //   "Unauthorized access: another device is using this account"
        // );
        removeSession();
        refreshPage();
      }
      return ({error: error.response});
  }
}

export const deleteSocialMedia = async (id) => {
  try {
      const response = await postAPICall(process.env.REACT_APP_LINK + "alumni_organizations/delete", {
          requester: user,
          token: token,
          alumni_id: user,
          // package_type_id: id,
      });
      return ({data:response});   
  } catch (error) {
      if (error.response.status === 401) {
        // toast.error(
        //   "Unauthorized access: another device is using this account"
        // );
        removeSession();
        refreshPage();
      }
      return ({error: error.response});
  }
}

//POST
export const editUser = async (info, branches, file) => {
  var branchesData = [];

  branches.map((data) => (
    branchesData.push(data.value)
  ));
  try {
    const formData = new FormData();
    //Change param name according to the asked param from API
    formData.append("file_result", file[0]);
    const response = await postAPICallCustom(
      process.env.REACT_APP_LINK + "/login",
      {
        // requester: user,
        token: token,
        username: info.username,
        password: info.password,
        last_name: info.last_name,
        first_name: info.first_name,
        middle_name: info.middle_name,
        email: info.email_address,
        type: info.user_type,
        role_id: info.role,
        branch_ids: branchesData.join(","),
      },
      {
        "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
        // "user-key": userKey,
        "Content-Type": "multipart/form-data",
      },
    );

    return { data: response };
  } catch (error) {
    return { data: error.response.data };
  }
};